/**
 * The bottom navbar intentionally no-ops when tapping the Wallet tab while
 * already on the wallet list page, to avoid an unnecessary re-navigation.
 * This must only apply to the exact wallet list path — nested wallet routes
 * (e.g. the transaction detail page) also live under `/wallet/*` but should
 * still navigate back to the list when the Wallet tab is tapped.
 */
export const shouldSkipNavbarNavigation = (
  actionRoute: string,
  walletListRoute: string,
  currentLocationPath: string,
): boolean =>
  actionRoute === walletListRoute && currentLocationPath === walletListRoute;
